import { TutorialStep } from '../types'
import { selectors } from '../selectors'
import { createTabAutoClickHandler } from '../stepManagement/actionHelpers'
import { waitForElementAndScroll } from '../stepManagement/elementUtils'

export const alertSteps: readonly TutorialStep[] = [
  {
    target: 'body',
    placement: 'center',
    title: 'Welcome to Alerts',
    section: 'Trade Alerts',
    disableBeacon: true,
    content:
      "Get instant notifications when your pattern's rules are met, keeping you informed about potential trade opportunities. This ensures you never miss a moment to execute a favorable trade.",
    isWelcomeScreen: true,
    video: 'alertsIntro',
  },
  {
    target: selectors.alertName,
    placement: 'bottom',
    title: 'Alert Name',
    content: 'The name describing the alert',
    section: 'Alerts Card',
    disableBeacon: true,
  },
  {
    target: selectors.alertPatternName,
    placement: 'bottom',
    title: 'Pattern Name',
    content: 'The pattern applied to this alert',
    section: 'Alerts Card',
    disableBeacon: true,
  },
  {
    target: selectors.alertContentSection,
    disableBeacon: true,
    placement: 'top',
    title: 'Status',
    content: "Live status updates of the pattern's rules",
    section: 'Alerts Card',
  },
  {
    target: selectors.alertTypeIcons,
    disableBeacon: true,
    placement: 'top',
    title: 'Notification Methods',
    content: 'Alert notification methods',
    section: 'Alerts Card',
  },
  {
    target: selectors.alertActiveSwitch,
    placement: 'bottom',
    title: 'Active Slider',
    content: 'Click the slider to activate or deactivate the alert',
    section: 'Alerts Card',
    disableBeacon: true,
  },
  {
    target: selectors.alertSettingsButton,
    disableBeacon: true,
    placement: 'top',
    title: 'Alert Details',
    content: 'Click here to View/Edit Alert Settings',
    section: 'Alert Details',
  },
  {
    beforeShowPromise: () => waitForElementAndScroll(selectors.alertSidePanelSettingsTab),
    target: selectors.alertSidePanelSettingsTab,
    placement: 'left',
    title: 'Settings',
    content: 'View alert settings',
    section: 'Alert Details',
    onEnter: createTabAutoClickHandler(selectors.alertSidePanelSettingsTab),
    disableBeacon: true,
  },
  {
    target: selectors.alertSidePanelHistoryTab,
    placement: 'left',
    title: 'History',
    content: 'View alert history',
    section: 'Alert Details',
    onEnter: createTabAutoClickHandler(selectors.alertSidePanelHistoryTab),
    disableBeacon: true,
  },
  {
    target: selectors.alertSidePanelPatternTab,
    placement: 'left',
    title: 'Pattern',
    content:
      'View and monitor the status of the alert. Rules that are checked are satisfied, rules that are orange can be expanded to view sub-rules and their status. When all rules are checked the pattern triggers and notifications are sent. Copy the pattern as your own.',
    section: 'Alert Details',
    onEnter: createTabAutoClickHandler(selectors.alertSidePanelPatternTab),
    disableBeacon: true,
  },
  {
    beforeShowPromise: () => waitForElementAndScroll(selectors.alertSidePanelActions),
    target: selectors.alertSidePanelActions,
    placement: 'top',
    title: 'Actions',
    content: 'You can delete, share with another member, or edit the alert',
    section: 'Alert Details',
    disableBeacon: true,
  },
  {
    target: selectors.createAlertButton,
    placement: 'left',
    title: 'Get Started',
    content: 'Click to create a new alert',
    section: 'Create Alert',
    disableBeacon: true,
  },
  {
    target: 'body',
    placement: 'center',
    title: 'Feedback',
    content:
      'Please rate this tutorial (1 - poor, 5 - exceptional). Please provide us details of your experience or suggestions on improving this tutorial.',
    section: 'Review',
    isFeedback: true,
    hideFooter: true,
    disableBeacon: true,
  },
]
